"use strict";

const isObject = a => a !== null && typeof a === 'object' && a.constructor === Object;

module.exports = isObject;